import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import type { RegistrationType } from '../../../../../../services/RegistrationService/types/registrationTypes';

/**
 * Hook for handling registration grid navigation
 */
export function useRegistrationNavigation(
  registrations: RegistrationType[],
  onSelectRegistration: (registration: RegistrationType) => void
) {
  const navigate = useNavigate();

  const handleRowSelection = useCallback(
    (args: any) => {
      if (args.data) {
        // Find the original registration object by ID
        const registration = registrations.find((reg) => reg.id === args.data.id);
        if (registration) {
          // Call the callback for any parent component logic
          onSelectRegistration(registration);

          // Navigate to the registration page with the required query parameters
          const company = registration.identifiers?.company || '';
          const center = registration.identifiers?.center || '';
          const mrn = registration.identifiers?.mrn || '';

          if (company && center && mrn) {
            navigate(
              `/Registration?company=${encodeURIComponent(company)}&center=${encodeURIComponent(center)}&mrn=${encodeURIComponent(mrn)}`
            );
          }
        }
      }
    },
    [registrations, onSelectRegistration, navigate]
  );

  return { handleRowSelection };
}
